import React from 'react';
import classNames from 'classnames';
import { useDeleteProjectTagMutation } from '../../store';
import { Modal } from '../../components';

export const DeleteTagModal = (props) => {
    const { show, onClose, projectId, tag } = props;
    const [deleteProjectTag] = useDeleteProjectTagMutation();

    const handleDelete = () => {
        deleteProjectTag({ id: projectId, tag: tag });
        onClose();
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="sm:container p-4">
                <h1>Delete this Tag?</h1>
                <div className="mb-4">
                    <div className="flex justify-between gap-4 mb-2">
                        <div>
                            <label
                                className={classNames(
                                    'block mb-2 text-sm font-medium',
                                )}
                            >
                                Tag
                            </label>
                            <div className="swegon-ui-text-input-wrapper">
                                <div>{tag.value}</div>
                            </div>
                        </div>
                        <div>
                            <label
                                className={classNames(
                                    'block mb-2 text-sm font-medium',
                                )}
                            >
                                Equipment Type
                            </label>
                            <div className="swegon-ui-text-input-wrapper">
                                <div>{tag.equipmentType}</div>
                            </div>
                        </div>
                        <div>
                            <label
                                className={classNames(
                                    'block mb-2 text-sm font-medium',
                                )}
                            >
                                Room
                            </label>
                            <div className="swegon-ui-text-input-wrapper">
                                <div>{tag.room}</div>
                            </div>
                        </div>
                        <div>
                            <label
                                className={classNames(
                                    'block mb-2 text-sm font-medium',
                                )}
                            >
                                Trade
                            </label>
                            <div className="swegon-ui-text-input-wrapper">
                                <div>{tag.trade}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        type="button"
                        className="swegon-like-button outlined mr-4 !px-4 amber"
                    >
                        Cancel
                    </button>
                    <button
                        className="swegon-like-button contained red"
                        type="submit"
                        onClick={handleDelete}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </Modal>
    );
};
